import { createAction, props, union } from '@ngrx/store';
import { AddTarQueryI } from '../../api/add-tar/add-tar.query.int';
import { AddTarResponseI } from '../../api/add-tar/add-tar.result.int';

export const loadAddTarAction = createAction('[ADD / Tar] Get', props<{ query: AddTarQueryI }>());
export const received = createAction('[ADD / Tar] Received', props<{ data: AddTarResponseI }>());
export const resetAddTarAction = createAction('[ADD / Tar] Reset', props<Record<string, unknown>>());
export const error = createAction('[ADD / Tar] Error', props<{ messageText: string }>());

const addTarAll = union({
  error,
  loadAddTarAction,
  received,
  resetAddTarAction,
});
export type Actions = typeof addTarAll;
